import { BaseApi } from '@/modules/core/base.api';
import { Device } from './device';
import { User } from '@/modules/user/user';
import * as API from '@shared/common/api';
class DeviceApi extends BaseApi {
    public apiPath = 'device';

    public async getCount(): Promise<API.GetDeviceCount> {
        const response = await this.api.get<API.GetDeviceCount>(this.baseUrlFor('count'));
        return response.data;
    }

    public async findAll(options = {}): Promise<any> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });
        return response.data;
    }

    public async get(id: string): Promise<Device> {
        const response = await this.api.get<API.GetDevice>(this.baseUrlFor(id));
        const device = new Device(response.data);
        if (device.owner) {
            device.owner = new User(device.owner);
        }

        if (device.createdBy) {
            device.createdBy = new User(device.createdBy);
        }

        if (device.updatedBy) {
            device.updatedBy = new User(device.updatedBy);
        }

        return device;
    }

    public async unassign(id: string): Promise<API.UnassignDevice> {
        const response = await this.api.put<API.UnassignDevice>(this.baseUrlFor(id, 'unassign'));
        return response.data;
    }

    public async create(device: any): Promise<API.CreateDevice> {
        try {
            const response = await this.api.post<API.CreateDevice>(this.baseUrlFor(), device);
            return response.data;
        } catch (e) {
            if (e.response) {
                if (e.response.data.code === 'MAX_DEVICE_COUNT_REACHED') {
                    e.translatedMsg = `Nombre maximum de terminaux atteint (MAX_DEVICE_COUNT_REACHED - ${e.response.data.max}), 
                    veuillez contacter votre administrateur présence verte`;
                }
            } else if (e.request) {
                e.translatedMsg = 'Aucune réponse du serveur';
            } else {
                e.translatedMsg = 'Erreur lors de la mise en place de la requête.';
            }

            throw e;
        }
    }

    public async update(device: any): Promise<API.UpdateDevice> {
        const response = await this.api.put<API.UpdateDevice>(this.baseUrlFor(device.id), device);
        return response.data;
    }

    public async delete(device:  Device): Promise<API.DeleteDevice> {
        const response = await this.api.delete<API.DeleteDevice>(this.baseUrlFor(device.id));
        return response.data;
    }

    public async syncConfiguration(deviceId: string): Promise<API.SyncDevice> {
        const response = await this.api.put<API.SyncDevice>(this.baseUrlFor(deviceId, 'sync'));
        return response.data;
    }

    public async setSubscriptionConfigBackToBase(deviceId: string): Promise<API.RevertDeviceSubscriptionToBase> {
        const response = await this.api.put<API.RevertDeviceSubscriptionToBase>(this.baseUrlFor(deviceId, 'revert_subscription_to_base'));
        return response.data;
    }

    public async notifyCGUUpdate(): Promise<void> {
        const response = await this.api.post<void>(this.baseUrlFor('notify_cgu_update'));
        return response.data;
    }

    async sendPushNotification(type: any): Promise<void> {
        switch (type) {
            case 'TOS_UPDATE':
                return await this.notifyCGUUpdate();

            default:
                break;
        }
    }

    async updatePinCode(deviceId: string, pinCode: string): Promise<void> {
        const response = await this.api.put<API.UpdateDevicePinCode>(this.baseUrlFor(deviceId, 'pin_code'), { pinCode });
        return response.data;
    }

    public getExportUrl(options?: any): string {
        return this.api.getUri({ url: this.baseUrlFor('export'), params: options ? { sort: options.sort, ...options.filters } : undefined });
    }
}

export const deviceApi = new DeviceApi();
